import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import { DragDropContext } from 'react-beautiful-dnd'
import { connect } from 'react-redux';
import * as categories from 'catalog/actions/categories';
import * as checkpoints from 'catalog/actions/checkpoints';
import * as measures from 'catalog/actions/measures';

@connect(
    null,
    dispatch => ({
        reorderCategoryList: result => dispatch(categories.reorderCategoryList(result)),
        reorderCheckpointList: result => dispatch(checkpoints.reorderCheckpointList(result)),
        reorderMeasureList: result => dispatch(measures.reorderMeasureList(result))
    })
)
export default class DnDContext extends Component {

    @autobind
    reorder(result) {
        if(!result.destination) {
            return;
        }
        if(result.type === 'category' || result.type === 'subcategory') {
            this.props.reorderCategoryList(result)
        }
        if(result.type === 'checkpoint') {
            this.props.reorderCheckpointList(result)
        }
        if(result.type === 'measure') {
            this.props.reorderMeasureList(result)
        }
    }

    render() {
        const {
            children
        } = this.props;

        return (
            <DragDropContext onDragEnd={this.reorder}>
                {children}
            </DragDropContext>
        )
    }
}